import { Pipe, PipeTransform } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
import { getPropertyTypeLabel } from '@miq/utils';

@Pipe({ name: 'translatePropertyType', standalone: true })
export class TranslatePropertyTypePipe implements PipeTransform {
  constructor(private translationService: L10nTranslationService) {}

  transform(value: string): string {
    const translationKey = 'propertyTypes.' + (value && value.toLowerCase());
    return this.translationService.has(translationKey)
      ? this.translationService.translate(translationKey)
      : getPropertyTypeLabel(value) || value;
  }
}
